

var CONTACT_FORM_ENDPOINT = "https://4d46fd63aa.us1.amezmo.co/upsert-contact.php";

$(function() {
    $(document).on('click', '.js-contact-form-submit, #btn_hero-form, #btn_footer-form', function(event) {
        event.preventDefault();
        sendFormDataToConstantContact($(this));
    });
});


function sendFormDataToConstantContact($submitButton) {

    var $formFields = $submitButton.closest('.form-fields');
    var $formInputs = $formFields.find('input, textarea, select');
    var $botTrapInput = $formFields.find('.ucom--textbox._is-bot-trap input');
    var isBot = $botTrapInput.val().length > 0;
    var emailIsValid = validateEmail($formFields.find('input.email').val(), false);
    var specialty = ($formFields.find('[data-contact-field="specialty"]').val() || '').trim();
    var payload = {
        page_title: document.title,
        page_url: window.location.href,
        form_source: $formFields.data('form-source') || 'website-form',
        fields: {}
    };

    if ($submitButton.hasClass('_waiting')
    ||  $submitButton.hasClass('_form-error')
    ||  $submitButton.hasClass('_form-success')
    ||  isBot) {
        return;
    }

    if (emailIsValid !== true) {
        showFormError($submitButton, emailIsValid);
        $formFields.find('input.email').focus().select();
        return;
    }

    if (specialty.length < 1 || specialty === 'did not select') {
        showFormError($submitButton, 'Please select an interest.');
        $formFields.find('[data-contact-field="specialty"]').focus();
        return;
    }

    $submitButton.addClass('_waiting');

    $.each($formInputs, function() {
        var $field = $(this);
        var fieldName = $field.data('contact-field') || $field.data('hsPropertyName');
        var value = ($field.val() || '').trim();

        if (!fieldName || $field.parent().hasClass('_is-bot-trap')) {
            return;
        }

        payload.fields[fieldName] = value;
    });

    $.ajax({
        url: CONTACT_FORM_ENDPOINT,
        method: 'POST',
        data: { payload: JSON.stringify(payload) }
    }).done(function(response) {
        var parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;
        var $submitButtonLabel = $submitButton.children('div.label');

        $submitButton.removeClass('_waiting');

        if (parsedResponse.status !== 'success') {
            showFormError($submitButton, parsedResponse.message || 'Unknown error');
            return;
        }

        $submitButton.addClass('_form-success');
        $submitButtonLabel.text('Request sent!');
        resetContactForm($formFields);

        if (typeof dataLayer !== 'undefined' && dataLayer.push) {
            dataLayer.push({
                'event': 'custom-page-form-submission',
                'conversionValue': 1
            });
        }

    }).fail(function() {
        $submitButton.removeClass('_waiting');
        showFormError($submitButton, 'Unable to submit right now.');
    });

}


function showFormError($submitButton, message) {

    var $submitButtonLabel = $submitButton.children('div.label');

    $submitButton.addClass('_form-error anim_wiggle-little');
    $submitButtonLabel.text(message);

    setTimeout(function() {
        $submitButton.removeClass('_form-error anim_wiggle-little');
        $submitButtonLabel.text($submitButton.data('initial-label'));
    }, 3000);

}


function resetContactForm($formFields) {

    $formFields.find('input, textarea, select').each(function() {
        var $field = $(this);
        var fieldName = $field.data('contact-field');

        if ($field.parent().hasClass('_is-bot-trap')) {
            $field.val('');
            return;
        }

        if (fieldName === 'specialty' && $field.attr('type') === 'hidden') {
            return;
        }

        if (this.tagName === 'SELECT') {
            this.selectedIndex = 0;
        } else if ($field.attr('type') !== 'hidden') {
            $field.val('');
        }
    });

}


function validateEmail(email, doStrictEmailCheck) {

    var errorMsg = '';

    if (email.length < 1) {
        errorMsg = 'Please provide your email.';
    }

    else if (email.length < 5
         ||  email.indexOf('@')  < 0
         ||  email.indexOf('.')  < 0
         ||  email.indexOf('@@') > 0
         ||  email.indexOf('..') > 0
         ||  email.indexOf('@.') > 0) {

        errorMsg = 'Invalid email format.';
    }

    else if (doStrictEmailCheck) {

        if (email.indexOf('@gmail.')   > 0
        ||  email.indexOf('@yahoo.')   > 0
        ||  email.indexOf('@ymail.')   > 0
        ||  email.indexOf('@hotmail.') > 0
        ||  email.indexOf('@aol.')     > 0
        ||  email.indexOf('@outlook.') > 0
        ||  email.indexOf('@icloud.')  > 0) {

            errorMsg = 'Please provide your work email address.';
        }

    }

    if (errorMsg) {
        return errorMsg;
    } else {
        return true;
    }

}
